// Labels and grouping for the transaction history (Settings > Transaction history).
// billingHistory (coinPurchaseHistory) mixes paid purchases with free credits.

export const coinsOf = (entry) => Number(entry.coins ?? entry.amount) || 0;

export const isPaidPurchase = (entry) =>
  entry.type !== "admin_award" &&
  (String(entry.purpose || "").startsWith("pro_purchase") ||
    entry.purpose === "pro_renewal" ||
    Number(entry.paidAmount) > 0 ||
    Number(entry.price) > 0);

const PRO_NAMES = { pro_monthly: "Pro · monthly", pro_onetime: "Pro · 1-month pass" };

export function purchaseTitle(entry) {
  if (entry.purpose === "pro_renewal") return "Pro · monthly renewal";
  if (entry.purpose === "pro_purchase") return PRO_NAMES[entry.productId] || "NameIt! Pro";
  return `${coinsOf(entry).toLocaleString()} coins`;
}

const SPEND_NAMES = {
  room_upgrade: "Extra room seats",
  ai_review: "AI answer review",
  extra_category: "Extra category",
  vote_reveal: "Revealed the votes",
  room_creation_bypass: "Extra room over the limit",
  power_up: "Power-up",
};

const CREDIT_NAMES = {
  pro_monthly_bonus: "Pro monthly coins",
  announcement_reward: "Reward",
  admin_award: "Gift from NameIt!",
  power_up_refund: "Power-up refund",
  room_creation_bypass_refund: "Refund",
};

export function spendTitle(purpose = "") {
  if (SPEND_NAMES[purpose]) return SPEND_NAMES[purpose];
  if (purpose.startsWith("hint_pack")) return "Hint pack";
  if (purpose.startsWith("hint")) return "Hint";
  return purpose ? purpose.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase()) : "Coins used";
}

export function creditTitle(entry) {
  if (entry.purpose === "daily_reward") return entry.streakDay ? `Daily reward · day ${entry.streakDay}` : "Daily reward";
  return CREDIT_NAMES[entry.purpose] || CREDIT_NAMES[entry.type] || entry.reason || "Free coins";
}
